import { Box } from '@mui/material';
import { FormProvider } from 'react-hook-form';
import { OryErrorBar } from '../../../../ory/components/OryErrorBar';
import { LoginAttemptsAlert } from '../../LoginAttemptsAlert';
import { AuthLoginForm } from './LoginForm';
import { useLoginForm } from './useLoginForm';

interface ILoginFormWrapperParams {
  onOrySecondFactor: () => void;
}

export function LoginFormWrapper(params: ILoginFormWrapperParams) {
  const { formData, getFormAlertMessage, handleFormSubmit, isOryApiFetching, isSSOLogin, retryAfterDate } =
    useLoginForm(params);

  return (
    <>
      <Box>
        <OryErrorBar error={getFormAlertMessage()} />
        {retryAfterDate && (
          <Box pb={3}>
            <LoginAttemptsAlert throttlingRetryAfter={retryAfterDate} />
          </Box>
        )}
      </Box>

      <FormProvider {...formData}>
        <form onSubmit={formData.handleSubmit(handleFormSubmit)}>
          <AuthLoginForm isSubmitDisabled={!formData.formState.isValid || isOryApiFetching} isSSOLogin={isSSOLogin} />
        </form>
      </FormProvider>
    </>
  );
}
